/** localStorage key：`moduleDefaultPaths:${userId}`，值為 JSON 物件 */
export const MODULE_DEFAULT_PATHS_STORAGE_KEY_PREFIX = "moduleDefaultPaths";

const REVX_USER_ID_STORAGE_KEY = "revxId";

/** 支援「設定母頁面首頁」的 Sidebar 模組名稱（不含請採驗，請採驗沿用原有機制） */
export const MODULES_WITH_DEFAULT_HOME = new Set([
  "options",
  "shiftschedule",
  "customer",
  "statistics",
]);

/** Sidebar 模組名稱 → 中文區塊名（與 SidebarType 一致） */
export const MODULE_DEFAULT_HOME_LABELS = {
  options: "設定",
  shiftschedule: "班表",
  customer: "會員",
  statistics: "數據",
};

export function getModuleDefaultHomeDialogTitle(routerName) {
  const label = MODULE_DEFAULT_HOME_LABELS[routerName];
  if (!label) return "設定區塊首頁";
  return `設定「${label} 」區塊首頁`;
}

export const MODULE_DEFAULT_PATH_CHANGED_EVENT = "moduleDefaultPathChanged";

/** 目前登入帳號 id（與登入流程寫入的 revxId 一致） */
export function getCurrentModuleDefaultUserId() {
  if (typeof window === "undefined") return null;
  const id = localStorage.getItem(REVX_USER_ID_STORAGE_KEY);
  return id != null && id !== "" ? String(id) : null;
}

export function getModuleDefaultPathsStorageKey(
  userId = getCurrentModuleDefaultUserId()
) {
  if (userId == null || userId === "") return null;
  return `${MODULE_DEFAULT_PATHS_STORAGE_KEY_PREFIX}:${String(userId)}`;
}

function parseStoredPaths(raw) {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch(err) {
    console.log("Error parsing stored paths", err);
    return {};
  }
}

function readAllSavedPaths(userId = getCurrentModuleDefaultUserId()) {
  if (typeof window === "undefined") return {};

  const key = getModuleDefaultPathsStorageKey(userId);
  if (!key) return {};

  return parseStoredPaths(localStorage.getItem(key));
}

function writeAllSavedPaths(
  paths,
  userId = getCurrentModuleDefaultUserId()
) {
  if (typeof window === "undefined") return;
  const key = getModuleDefaultPathsStorageKey(userId);
  if (!key) return;
  localStorage.setItem(key, JSON.stringify(paths));
}

export function normalizeModulePath(path) {
  if (!path || typeof path !== "string") return "";
  const trimmed = path.trim();
  if (!trimmed) return "";
  const withLeading = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeading.replace(/\/+$/, "") || "/";
}

export function getSavedModuleDefaultPath(
  sidebarName,
  userId = getCurrentModuleDefaultUserId()
) {
  if (!sidebarName) return null;
  const paths = readAllSavedPaths(userId);
  const saved = paths[sidebarName];
  return saved ? normalizeModulePath(saved) : null;
}

export function hasUserConfiguredModuleDefault(
  sidebarName,
  userId = getCurrentModuleDefaultUserId()
) {
  return Boolean(getSavedModuleDefaultPath(sidebarName, userId));
}

export function persistModuleDefaultPath(
  sidebarName,
  path,
  userId = getCurrentModuleDefaultUserId()
) {
  if (typeof window === "undefined" || !sidebarName || !path) return;
  const key = getModuleDefaultPathsStorageKey(userId);
  if (!key) return;

  const paths = readAllSavedPaths(userId);
  paths[sidebarName] = normalizeModulePath(path);
  writeAllSavedPaths(paths, userId);

  window.dispatchEvent(
    new CustomEvent(MODULE_DEFAULT_PATH_CHANGED_EVENT, {
      detail: { sidebarName, path: paths[sidebarName], userId },
    })
  );
}

export function clearModuleDefaultPath(
  sidebarName,
  userId = getCurrentModuleDefaultUserId()
) {
  if (typeof window === "undefined" || !sidebarName) return;
  const key = getModuleDefaultPathsStorageKey(userId);
  if (!key) return;

  const paths = readAllSavedPaths(userId);
  delete paths[sidebarName];
  writeAllSavedPaths(paths, userId);

  window.dispatchEvent(
    new CustomEvent(MODULE_DEFAULT_PATH_CHANGED_EVENT, {
      detail: { sidebarName, path: null, userId },
    })
  );
}

export function isSameModulePath(pathA, pathB) {
  return normalizeModulePath(pathA) === normalizeModulePath(pathB);
}
